module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/19ea1146c79e5305c5db33f5e1e78ef3.png";